export default {
    // récuperer toutes les guichets dans la base de données 
    get_all_typeoperations(serverParams){
        return axios.post('/typeoperation/list?page=' + serverParams.page, serverParams, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },

    // récuperer toutes les guichets dans la base de données 
    typeoperations(){
        return axios.get('/typeoperations', {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },

    get_all_sensoperations(){
        return axios.get('/sensoperations', {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    // récuperer toutes les guichets dans la base de données 
    post_typeoperations(typeoperation){
        return axios.post('/typeoperations', typeoperation, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    put_typeoperations(id, typeoperation){
        return axios.put('/typeoperations/' + id, typeoperation, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    show_typeoperations(id){
        return axios.get('/typeoperations/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    delete_typeoperations(id){
        return axios.delete('/typeoperations/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        })
    },

}